// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2woTk","name":"ConsentHeader_name__11k1T","birthday":"ConsentHeader_birthday__3eQZf","skeleton":"ConsentHeader_skeleton__3pJGU"};